import React, { Component } from "react"
import Img from "gatsby-image/withIEPolyfill"
import BlockContent from "@sanity/block-content-to-react"
import { SecondaryTitle } from "../../styled-components/SecondaryTitle"
import { ProjectText } from "../../styled-components/ProjectText"
import styled from "styled-components"
import { colors } from "../../colors/colors"
import { serializers } from "../../../libs/serializer"
const PhotoProjectContainer = styled.div`
  width: 100%;
  max-width: 960px;
`

const PhotoBox = styled.div`
  display: grid;
  grid-template-rows: 1fr 50px 1fr;
  grid-template-columns: 50px 1fr 50px;

  @media (max-width: 812px) {
    width: 90%;
    margin: 0 auto;
  }
`

const BackArrow = styled.div`
  padding: 10px;
  font-size: 40px;
  grid-column: 1/2;
  grid-row: 2/3;
  color: ${colors.white};
  z-index: 10;
  cursor: pointer;
`

const ForwardArrow = styled(BackArrow)`
  grid-column: 3/4;
  grid-row: 2/3;
`

const PagePhoto = styled(Img)`
  width: 100%;
  height: 600px;
  grid-column: 1/4;
  grid-row: 1/4;

  @media (max-width: 812px) {
    width: 100%;
    height: 300px;
  }
`

class PhotoProjectPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageIndex: 0,
      showArrows: false,
    }
    this.showArrows = this.showArrows.bind(this)
    this.hideArrows = this.hideArrows.bind(this)
    this.incrementSlide = this.incrementSlide.bind(this)
    this.decrementSlide = this.decrementSlide.bind(this)
  }

  showArrows() {
    this.setState({ showArrows: true })
  }

  hideArrows() {
    this.setState({ showArrows: false })
  }

  incrementSlide() {
    let numberOfPhotos = this.props.images.length
    const one = 1
    numberOfPhotos = numberOfPhotos - one
    let slideIndex = this.state.imageIndex
    slideIndex++

    if (slideIndex > numberOfPhotos) {
      slideIndex = 0
      this.setState({ imageIndex: slideIndex })
    }

    this.setState({ imageIndex: slideIndex })
  }

  decrementSlide() {
    let numberOfPhotos = this.props.images.length
    const one = 1
    numberOfPhotos = numberOfPhotos - one
    let slideIndex = this.state.imageIndex
    slideIndex--

    if (slideIndex <= 0) {
      slideIndex = numberOfPhotos
      this.setState({ imageIndex: slideIndex })
    }
    this.setState({ imageIndex: slideIndex })
  }

  render() {
    const i = this.state.imageIndex
    const arrowView = this.state.showArrows
    const backArrow = "<"
    const forwardArrow = ">"

    return (
      <PhotoProjectContainer>
        <PhotoBox onMouseEnter={this.showArrows} onMouseLeave={this.hideArrows}>
          {arrowView ? (
            <BackArrow onClick={this.decrementSlide}> {backArrow} </BackArrow>
          ) : (
            ""
          )}
          <PagePhoto
            fluid={this.props.images[i].asset.fluid}
            objectFit={"scale-down"}
          />
          {arrowView ? (
            <ForwardArrow onClick={this.incrementSlide}>
              {" "}
              {forwardArrow}{" "}
            </ForwardArrow>
          ) : (
            ""
          )}
        </PhotoBox>
        <SecondaryTitle>{this.props.title}</SecondaryTitle>
        <ProjectText>
          <BlockContent blocks={this.props.text} serializers={serializers}/>
          <BlockContent blocks={this.props.text} serializers={serializers} />
        </ProjectText>
      </PhotoProjectContainer>
    )
  }
}

export default PhotoProjectPage
